import { ClientWithAuth, setCustomRequestId } from 'client/services/service';
import { extractEnquiryFileName } from 'client/utils/helpers/Enquiry/Enquiry';
import { log } from 'client/utils/logging/logging';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';

const serviceUrlSuffix = '/enquiry-service';
const mapfishUrlSuffix = '/mapfish';

export default {
    getEnquiry: async (enquiryId) => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/enquiry/${enquiryId}`);
        return {
            ...response.data
        };
    },
    getEnquiries: async (params) => {
        const epsgCode = await getEpsgCode();
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/${epsgCode}/enquiry`, { params });
        return {
            ...response.data
        };
    },
    postEnquiry: async (enquiry, requestId) => {
        const epsgCode = await getEpsgCode();
        // overload PDF report generation: this takes a long time so increase to 1.5 minutes before 'give up'
        const timeout = 90000;
        const headers = requestId ? setCustomRequestId(ClientWithAuth.defaults.headers, requestId) : ClientWithAuth.defaults.headers;
        const response = await ClientWithAuth.post(`${serviceUrlSuffix}/${epsgCode}/enquiry`, JSON.stringify(enquiry), { headers }, { timeout: timeout });
        return {
            ...response.data
        };
    },
    deleteEnquiries: async (enquiryIds) => {
        const response = await ClientWithAuth.delete(`${serviceUrlSuffix}/enquiry`, { data: enquiryIds });
        return {
            ...response?.data
        };
    },
    getPdfCapabilities: async () => {
        const response = await ClientWithAuth.get(`${mapfishUrlSuffix}/capabilities`);

        // transform into an easier-to-consume format that only gives us what we actually need
        return {
            layouts: response.data.layouts.map(layout => {
                return {
                    name: layout.name,
                    scales: layout.attributes.find(attr => attr.name === 'map')?.clientInfo.scales || []
                };
            })
        };
    },
    getActivityTypes: async (locale) => {
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/activityTypes`);
        return response.data.activityTypes;
    },
    downloadPdf: async (enquiryId, workpackId) => {
        const config = { responseType: 'blob' };
        const response = await ClientWithAuth.get(`${serviceUrlSuffix}/enquiry/${enquiryId}/workpack/${workpackId}/download`, config);
        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        try {
            const fileName = extractEnquiryFileName(response.headers['content-disposition'], enquiryId);
            link.href = href;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (err) {
            log('Enquiry', 'Exception thrown on document download', 'ERROR');
        }
    }
};
